import styled from "styled-components";

export const StyledListItem = styled.div`
  display: flex;
  width: 100%;
  gap: 0.6rem;
  align-items: start;
`;

export const ImgSrc = styled.span`
  margin-top: 10px;
  margin-left: 15px;
  font-size: 16px;
  position: relative;
  top: 0.2rem;
`;